var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.remoteDatasetLoaded)?_c('IconCarouselElement',{attrs:{"icon-name":_vm.iconNameRemote,"headline":_vm.headline,"text":_vm.text}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }